import { useState } from "react";
import { Input, Button, Col, Row } from "reactstrap";
import axios from "../../services/api/api";
import { toast } from "react-toastify";
import { FormattedMessage, useIntl } from "react-intl";
import { formatServiceError } from "../../Utilities/serviceErrorHelper";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";
import Select from "react-select";
import { GetFortnoxPrograms } from "../../actions/adminQueries";

export default function CleanLicense() {
  const intl = useIntl();
  const fortNoxPrograms = GetFortnoxPrograms();
  const [selectedLicenseId, setSelectedLicenseId] = useState(null);
  const [email, setEmail] = useState("");
  const [emailEmptyError, setEmailEmptyError] = useState(false);
  const [selectedLicenseEmptyError, setSelectedLicenseEmptyError] =
    useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const licenseOptions =
    fortNoxPrograms?.data
      ?.filter((p) => !p.isAplProgram)
      .map((p) => ({
        value: p.id,
        label: p.licenseName,
      })) ?? [];

  const handleCleanLicense = async () => {
    if (!email) {
      return setEmailEmptyError(true);
    }
    if (!selectedLicenseId) {
      return setSelectedLicenseEmptyError(true);
    }

    setIsSubmitting(true);

    await axios
      .post("/Student/CleanLicense", {
        fortNoxProgramToKeepId: selectedLicenseId,
        studentEmail: email,
      })
      .then((res) => {
        toast.success(res.data.result, TOAST_CONFIG);
      })
      .catch((err) => {
        toast.warn(formatServiceError(intl, err?.response?.data), TOAST_CONFIG);
      });

    setIsSubmitting(false);
  };

  return (
    <div className="container-fluid admin-container">
      <Row>
        <Col xs="3" className="mb-2">
          <h5 className="no-margin">
            <FormattedMessage id="CleanLicense" />
          </h5>
        </Col>
      </Row>

      <Row>
        <Col xs="3" className="mb-2">
          <Input
            id="clean-license-email"
            placeholder={intl.formatMessage({ id: "StudentEmail" })}
            value={email}
            onChange={(e) => {
              setEmail(e.target.value.trim());
              setEmailEmptyError(false);
            }}
          />
          {emailEmptyError && (
            <div className="text-danger input-feedback">
              <FormattedMessage id="Views.Admin.CreateTeacherForm.Error.RequireEmail" />
            </div>
          )}
        </Col>
      </Row>

      <Row>
        <Col xs="3" className="mb-2">
          <Select
            name="programLicenses"
            placeholder={intl.formatMessage({ id: "ChooseLicenseToKeep" })}
            noOptionsMessage={() => intl.formatMessage({ id: "NoAvailableLicenses" })}
            options={licenseOptions}
            onChange={(e) => {
              setSelectedLicenseId(e.value);
              setSelectedLicenseEmptyError(false);
            }}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 99 }) }}
          />
          {selectedLicenseEmptyError && (
            <div className="text-danger input-feedback">
              <FormattedMessage id="MustSelectLicenseToKeep" />
            </div>
          )}
        </Col>
      </Row>

      <Row>
        <Col xs="4" className="mb-2 text-danger input-feedback">
          <FormattedMessage id="OtherLicensesWillBeRemovedNote" />
        </Col>
      </Row>

      <Row>
        <Col>
          <Button
            color="primary"
            outline
            id="button-clean-license"
            disabled={isSubmitting}
            onClick={handleCleanLicense}
          >
            {isSubmitting ? (
              <FormattedMessage id="Wait" />
            ) : (
              <FormattedMessage id="Clean" />
            )}
          </Button>
        </Col>
      </Row>
    </div>
  );
}
